<template>
  <b-row>
    <b-col class="pr-0">
      <b-form-group>
        <b-input-group size="sm">
          <b-form-input
            v-model="code"
            :placeholder="trans('code')"
            :state="validation"
            style="text-transform:uppercase"
            :disabled="busy"
            @keydown="onKeydown"
          />
          <b-input-group-append>
            <b-button variant="info" :disabled="busy || !code" @click="onSubmit">
              <span v-if="!busy"><i class="fa fa-fw fa-arrow-right"></i></span>
              <span v-if="busy"><i class="fa fa-fw fa-circle-notch fa-spin"></i></span>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-invalid-feedback :state="validation">
          {{ error }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col class="col-auto pl-0">
      <b-form-group class="d-inline-block">
        <b-button variant="link" size="sm" class="text-danger" :disabled="busy" @click="$emit('close')" :title="trans('remove')">
          <i class="fa fa-fw fa-times"></i>
        </b-button>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    props: {
      organization: Object,
      invoice: Object,
      invoice_item: Object,
      coupon: String,
      type: {
        type: String,
        default: 'package',
      },
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        code: this.invoice_item.coupon ? this.invoice_item.coupon.code : (this.invoice_item.promo_code ? this.invoice_item.promo_code : this.coupon ? this.coupon : null),
      }
    },
    computed: {
      validation() {
        return this.error ? false : null
      },
      codeUppercase() {
        return !this.code ? this.code : this.code.toUpperCase()
      },
    },
    methods: {
      onKeydown(e) {
        if (e.keyCode == 13) this.onSubmit()
      },
      onSubmit() {
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/cart/${this.type}/${this.invoice_item.id}/coupon/${encodeURIComponent(this.codeUppercase)}`
        axios.post(url)
        .then(response => {
          this.busy = false
          this.$emit('invoice', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window['applyCoupon_' + this.invoice_item.id] = this
      if (this.coupon) {
        this.onSubmit()
      }
    },
  }
</script>
